import React, { useContext, useState } from "react";
import Header2 from "../../Layout/Header2";
import pencil from "../../Images/fi_2682835.png";
import userimg from "../../Images/Ellipse 1582.png";
import thunder from "../../Images/Vector (7).png";
import whitePencil from "../../Images/whitePencil.png";
import avatar from "../../Images/avatar.jpg";
import bg from "../../Images/Rectangle 34624331.png";
import remove from "../../Images/delete.png";
import camera from "../../Images/Group 1171279372.png";
import { Context } from "../..";
import HttpClientXml from "../../utils/HttpClientXml";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import HomeService from "../../Services/HomeService";
const EditProfile = () => {
  const { loggedInUser, setLoggedInUser } = useContext(Context);
  const [imageUpload, setImageUpload] = useState("");

  const NavigateTo = useNavigate();
  const location = useLocation();
  const currentPassword = location.state?.currentPassword;

  console.log("EWQ24", currentPassword);


  const [formDataForEdit, setFormDataForEdit] = useState({
    address: loggedInUser.address,
    companyName: loggedInUser.companyName,
    email: loggedInUser.email,
    fullName: loggedInUser.fullName,
    image: loggedInUser.image,
    mobileNo: loggedInUser.mobileNo,
  });

  const [editPassword, setEditPassword] = useState({
    oldPassword: currentPassword,
    currentPassword: "",
    newPassword: ""
  })
  console.log("CFT30", formDataForEdit);

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("image", file);
      try {
        const response = await HttpClientXml.fileUplode(
          "image-upload",
          "POST",
          formData
        );
        if (response?.status) {
          setImageUpload(response.image);
          toast.success("Image successfully Selected!");
          setFormDataForEdit({ ...formDataForEdit, image: response.image });
          //console.log("formdata", formDataForEdit);
        } else {
          toast.error("Image Upload Failed!");
          console.error("Failed to upload image");
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    }
  };

  const handleChange = (e) => {
    setFormDataForEdit({ ...formDataForEdit, [e.target.name]: e.target.value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    // const data = {
    //   fullName: profile.fullName,
    //   city: profile.city,
    //   address: profile.address,
    //   mobileNo: profile.mobileNo,
    //   companyName: profile.companyName,
    //   image: image,
    //   workExpYear: Number(profile.workExpYear),
    // };
    const data = { ...formDataForEdit };
    try {
      const res = await HomeService.updateProfile(data);
      if (res?.status) {
        toast.success("Profile Updated Successfully!");
        NavigateTo("/profile");
      } else {
        toast.error(res.message);
        console.error("Profile cannot be updated");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if(editPassword.oldPassword !== editPassword.currentPassword){
      return toast.error("Current password is wrong.")
    }
    console.log("WER105",editPassword);
    // return
    const data = { password: editPassword.newPassword };
    try {
      const res = await HomeService.updateProfile(data);
      if (res?.status) {
        toast.success("Password Updated Successfully!");
        NavigateTo("/profile");
      } else {
        toast.error(res.message);
        console.error("Password cannot be updated");
      }
    } catch (error) {
      console.error("Error updating Password:", error);
    }
  };

  return (
    <>
      <>
        <Header2 />
        <div
          className="pricing_plans_container user_profile_container56856"
          style={{
            position: "relative",
          }}
        >
          <img
            alt="background"
            src={bg}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />

          {/* <button className="edit_profile_btn">
            {" "}
            <img src={pencil} />
            Change Cover
          </button> */}
        </div>
        <div className="user_container56556">
          <div className="user_card_wrapper">
            <div className="left_user_card_div">
              <div className="profile_information_div">
                <div
                  style={{
                    position: "relative",
                  }}
                >
                  <img
                    alt="user photo"
                    className="user_img_profile"
                    src={formDataForEdit.image || avatar}
                  />
                  <img
                    alt="camera"
                    style={{
                      position: "absolute",
                      width: "40px",
                      bottom: "5px",
                      right: "10px",
                      cursor: "pointer",
                    }}
                    src={camera}
                    onClick={() =>
                      document.getElementById("imageInput").click()
                    }
                  />
                  {formDataForEdit.image ? (
                    <img
                      alt="camera"
                      style={{
                        position: "absolute",
                        width: "30px",
                        bottom: "5px",
                        left: "10px",
                        cursor: "pointer",
                      }}
                      src={remove}
                      onClick={() => {
                        setFormDataForEdit({ ...formDataForEdit, image: "" });
                        toast.error("Image Deleted Successfully!");
                      }}
                    />
                  ) : null}
                </div>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  id="imageInput"
                  style={{ display: "none" }}
                />

                <h2>{loggedInUser.fullName}</h2>
                {/* <p>Private Employee</p> */}
                <div className="client_hand_propert_hand_div_wrapper">
                  <div
                    className="personal_details_1"
                    style={{
                      padding: "0px 20px",
                    }}
                  >
                    <h5>Client In Hand</h5>
                    {/* <h6>5 C flat for purchase in Kanpur.</h6> */}
                    <h6>{`${loggedInUser.clientsInHandCount} clients in hand`}</h6>
                  </div>

                  <div
                    className="personal_details_1"
                    style={{
                      marginTop: "15px",
                      borderTop: "1px solid rgba(0, 0, 0, 0.1)",
                      borderBottom: "1px solid rgba(0, 0, 0, 0.1)",
                      padding: "15px 20px",
                    }}
                  >
                    <h5>Property In Hand</h5>
                    {/* <h6>2000 Sq. feet flat in Kanpur.</h6> */}
                    <h6>{`${loggedInUser.propertiesInHandCount} clients in hand`}</h6>
                  </div>
                </div>
                {/* <button
                  className="discover_btn_5"
                  style={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    columnGap: "10px",
                  }}
                >
                  <img
                    style={{
                      width: "10px",
                    }}
                    src={thunder}
                  />
                  Message
                </button> */}
              </div>
            </div>
            <div className="right_user_card_div">
              <form
                style={{
                  width: "100%",
                }}
              >
                <div className="form_div_wrapper898745">
                  <div className="form_div585">
                    <label>Name</label>
                    <input
                      type="text"
                      value={formDataForEdit.fullName}
                      name="fullName"
                      onChange={handleChange}
                    ></input>
                  </div>

                  {/* <div className="form_div585">
                    <label>Last Name</label>
                    <input type="text"></input>
                  </div> */}

                  <div className="form_div585">
                    <label>Phone Number</label>
                    <input
                      type="text"
                      value={formDataForEdit.mobileNo}
                      name="mobileNo"
                      onChange={handleChange}
                    ></input>
                  </div>

                  <div className="form_div585">
                    <label>Email Address</label>
                    <input
                      type="text"
                      value={formDataForEdit.email}
                      name="email"
                      onChange={handleChange}
                    ></input>
                  </div>

                  <div className="form_div585">
                    <label>Address</label>
                    <input
                      type="text"
                      value={formDataForEdit.address}
                      name="address"
                      onChange={handleChange}
                    ></input>
                  </div>

                  <div className="form_div585">
                    <label>Company Name</label>
                    <input
                      type="text"
                      value={formDataForEdit.companyName}
                      name="companyName"
                      onChange={handleChange}
                    ></input>
                  </div>

                  {/* <div className="form_div585">
                    <label>Working Localities</label>
                    <input type="text"></input>
                  </div> */}
                </div>

                {/* <button
                  className="cancel_btn7895"
                  onClick={() => {
                    NavigateTo("/profile");
                  }}
                >
                  Cancel
                </button> */}
                <Link to="/profile" className="cancel_btn7895" style={{textDecoration:"none",color:"#000"}}>Cancel</Link>
                <button className="save_btn7895" onClick={handleSave}>
                  Save
                </button>
              </form>

              <form
                style={{
                  width: "100%",
                  margin:"25px 0",
                  borderTop:"1px solid rgba(0, 0, 0, 0.1)"
                }}
              >
                <div className="form_div_wrapper898745">
                  <div className="form_div585">
                    <label>Current Password</label>
                    <input
                      type="password"
                      value={setEditPassword.currentPassword}
                      name="currentPassword"
                      onChange={(e) => setEditPassword({ ...editPassword, currentPassword: e.target.value })}
                    ></input>
                  </div>

                  {/* <div className="form_div585">
                    <label>Last Name</label>
                    <input type="text"></input>
                  </div> */}

                  <div className="form_div585">
                    <label>New Password</label>
                    <input
                      type="text"
                      value={setEditPassword.newPassword}
                      name="newPassword"
                      onChange={(e) => setEditPassword({ ...editPassword, newPassword: e.target.value })}
                    ></input>
                  </div>
                </div>


                <button className="save_btn7895" onClick={handleChangePassword}>
                  Change Password
                </button>
              </form>
            </div>


          </div>
        </div>
      </>
    </>
  );
};

export default EditProfile;
